function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var PublishTemplate = require('./publish.template');
var _require = require('./overlay.shell'),
  applyPublishOverlayShell = _require.applyPublishOverlayShell;
var _require2 = require('../script_build'),
  lockingView = _require2.lockingView;
function escapeHtml(text) {
  return String(text || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatScriptForDisplay(script) {
  return JSON.stringify(script, null, 2);
}
function parseSaitoAmount(raw) {
  var allowZero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var text = String(raw || '').trim();
  if (!text && allowZero) {
    return '0';
  }
  if (!text) {
    return null;
  }
  var num = Number(text);
  if (!Number.isFinite(num) || num < 0) {
    return null;
  }
  if (!allowZero && num <= 0) {
    return null;
  }
  return text;
}
var PublishFlow = /*#__PURE__*/function () {
  function PublishFlow(app, mod, mainUi) {
    var _this = this;
    _classCallCheck(this, PublishFlow);
    this.app = app;
    this.mod = mod;
    this.mainUi = mainUi;
    this.overlay = new SaitoOverlay(app, mod, true, true, false);
    this.overlay["class"] = 'saito-overlay rs-publish-overlay-shell';
    this.overlay.clickBackdropToClose = true;
    this.overlay.nonBlocking = false;
    this.step = null;
    this.p2shAddress = '';
    this.p2shHash = '';
    this.lastPublishedTx = null;
    this.availableBalanceNolan = BigInt(0);
    this.blockedRoot = null;
    this.onEscapeKey = function (event) {
      if (event.key === 'Escape' && _this.step) {
        _this.hide();
      }
    };
  }
  return _createClass(PublishFlow, [{
    key: "openChoice",
    value: function openChoice() {
      this.step = 'choice';
      this.show(PublishTemplate.choiceOverlay());
      this.bindChoiceEvents();
    }
  }, {
    key: "openSend",
    value: function () {
      var _openSend = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var locking, hash, address, defaultFee, fee;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              locking = lockingView(this.mod.getScript());
              hash = this.app.core.scripting.hash(locking);
              address = this.app.core.scripting.address(locking);
              if (!(!hash || !address)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              this.p2shAddress = address;
              this.p2shHash = hash;
              defaultFee = this.app.wallet.convertNolanToSaito(this.app.wallet.default_fee || BigInt(0));
              fee = defaultFee && defaultFee !== '0.00' ? defaultFee : '0.001';
              _context.n = 2;
              return this.app.wallet.getBalance();
            case 2:
              this.availableBalanceNolan = _context.v;
              this.step = 'send';
              this.show(PublishTemplate.sendOverlay({
                scriptDisplay: escapeHtml(formatScriptForDisplay(locking)),
                p2shAddress: escapeHtml(address),
                amount: '1',
                fee: fee
              }));
              this.bindSendEvents();
            case 3:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function openSend() {
        return _openSend.apply(this, arguments);
      }
      return openSend;
    }()
  }, {
    key: "show",
    value: function show(html) {
      var _this2 = this;
      document.body.classList.add('rs-publish-modal-open');
      this.blockedRoot = document.querySelector('main.rustscript');
      if (this.blockedRoot) {
        this.blockedRoot.inert = true;
      }
      document.addEventListener('keydown', this.onEscapeKey);
      this.overlay.show(html, function () {
        _this2.onOverlayClosed();
      });
      this.applyOverlayLayout();
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.step) {
        this.overlay.close();
      }
    }
  }, {
    key: "onOverlayClosed",
    value: function onOverlayClosed() {
      document.body.classList.remove('rs-publish-modal-open');
      document.removeEventListener('keydown', this.onEscapeKey);
      if (this.blockedRoot) {
        this.blockedRoot.inert = false;
        this.blockedRoot = null;
      }
      this.step = null;
    }
  }, {
    key: "applyOverlayLayout",
    value: function applyOverlayLayout() {
      applyPublishOverlayShell(this.overlay);
    }
  }, {
    key: "insufficientBalanceMessage",
    value: function insufficientBalanceMessage(balanceNolan) {
      var maxDisplay = this.app.wallet.convertNolanToSaito(balanceNolan);
      return "Insufficient balance. Maximum available: ".concat(maxDisplay, " SAITO.");
    }
  }, {
    key: "bindChoiceEvents",
    value: function bindChoiceEvents() {
      var _root$querySelector,
        _this3 = this,
        _root$querySelector2;
      var root = document.querySelector('.rs-publish-choice');
      if (!root) {
        return;
      }
      (_root$querySelector = root.querySelector('[data-action="publish-saito"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function () {
        _this3.openSend();
      });
      (_root$querySelector2 = root.querySelector('[data-action="publish-nft"]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('click', function () {
        var _this3$mainUi;
        _this3.hide();
        (_this3$mainUi = _this3.mainUi) === null || _this3$mainUi === void 0 || (_this3$mainUi = _this3$mainUi.publishNftFlow) === null || _this3$mainUi === void 0 || _this3$mainUi.openSend();
      });
    }
  }, {
    key: "bindSendEvents",
    value: function bindSendEvents() {
      var _root$querySelector3,
        _root$querySelector5,
        _this4 = this;
      var root = document.querySelector('.rs-publish-send');
      if (!root) {
        return;
      }
      var errorEl = root.querySelector('.rs-publish-error');
      var showError = function showError(msg) {
        if (!errorEl) {
          return;
        }
        errorEl.textContent = msg;
        errorEl.hidden = !msg;
      };
      (_root$querySelector3 = root.querySelector('[data-action="publish-copy-hash"]')) === null || _root$querySelector3 === void 0 || _root$querySelector3.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _root$querySelector4;
        var hash, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              hash = (_root$querySelector4 = root.querySelector('.rs-publish-address')) === null || _root$querySelector4 === void 0 ? void 0 : _root$querySelector4.value;
              if (hash) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.p = 1;
              _context2.n = 2;
              return navigator.clipboard.writeText(hash);
            case 2:
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
            case 4:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      })));
      (_root$querySelector5 = root.querySelector('[data-action="publish-broadcast"]')) === null || _root$querySelector5 === void 0 || _root$querySelector5.addEventListener('click', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _root$querySelector6, _root$querySelector7;
        var amountRaw, feeRaw, amount, fee, balance, amountNolan, feeNolan, btn, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              showError('');
              amountRaw = (_root$querySelector6 = root.querySelector('.rs-publish-amount')) === null || _root$querySelector6 === void 0 ? void 0 : _root$querySelector6.value;
              feeRaw = (_root$querySelector7 = root.querySelector('.rs-publish-fee')) === null || _root$querySelector7 === void 0 ? void 0 : _root$querySelector7.value;
              amount = parseSaitoAmount(amountRaw, false);
              fee = parseSaitoAmount(feeRaw, true);
              if (amount) {
                _context3.n = 1;
                break;
              }
              showError('Enter a valid amount of SAITO.');
              return _context3.a(2);
            case 1:
              if (!(fee === null)) {
                _context3.n = 2;
                break;
              }
              showError('Enter a valid fee.');
              return _context3.a(2);
            case 2:
              _context3.n = 3;
              return _this4.app.wallet.getBalance();
            case 3:
              balance = _context3.v;
              _this4.availableBalanceNolan = balance;
              amountNolan = _this4.app.wallet.convertSaitoToNolan(amount);
              feeNolan = _this4.app.wallet.convertSaitoToNolan(fee || '0');
              if (!(balance < amountNolan + feeNolan)) {
                _context3.n = 4;
                break;
              }
              showError(_this4.insufficientBalanceMessage(balance));
              return _context3.a(2);
            case 4:
              btn = root.querySelector('[data-action="publish-broadcast"]');
              if (btn) {
                btn.disabled = true;
                btn.textContent = 'Publishing…';
              }
              _context3.p = 5;
              _context3.n = 6;
              return _this4.broadcastPublish(amount, fee || '0', {
                callback: function callback(result) {
                  if ((result === null || result === void 0 ? void 0 : result.status) === 'confirmed') {
                    var _this4$mainUi, _this4$mainUi$openPos;
                    (_this4$mainUi = _this4.mainUi) === null || _this4$mainUi === void 0 || (_this4$mainUi$openPos = _this4$mainUi.openPostPublish) === null || _this4$mainUi$openPos === void 0 || _this4$mainUi$openPos.call(_this4$mainUi, {
                      tx: result.tx || _this4.lastPublishedTx,
                      p2shAddress: _this4.p2shAddress,
                      p2shHash: _this4.p2shHash,
                      blockId: result.blockId,
                      txOrdinal: result.txOrdinal,
                      blk: result.blk
                    });
                  }
                }
              });
            case 6:
              _this4.hide();
              _context3.n = 8;
              break;
            case 7:
              _context3.p = 7;
              _t2 = _context3.v;
              showError((_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || 'Could not publish the transaction.');
              if (btn) {
                btn.disabled = false;
                btn.textContent = 'Publish';
              }
            case 8:
              return _context3.a(2);
          }
        }, _callee3, null, [[5, 7]]);
      })));
    }
  }, {
    key: "broadcastPublish",
    value: function () {
      var _broadcastPublish = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(amountSaito, feeSaito) {
        var _ref3,
          _ref3$callback,
          callback,
          locking,
          hash,
          address,
          amountNolan,
          feeNolan,
          balance,
          totalNeeded,
          newtx,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _ref3 = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {}, _ref3$callback = _ref3.callback, callback = _ref3$callback === void 0 ? null : _ref3$callback;
              locking = lockingView(this.mod.getScript());
              hash = this.app.core.scripting.hash(locking);
              address = this.app.core.scripting.address(locking);
              if (!(!hash || !address)) {
                _context4.n = 1;
                break;
              }
              throw new Error('Could not derive script address');
            case 1:
              this.p2shAddress = address;
              this.p2shHash = hash;
              amountNolan = this.app.wallet.convertSaitoToNolan(amountSaito);
              feeNolan = this.app.wallet.convertSaitoToNolan(feeSaito);
              _context4.n = 2;
              return this.app.wallet.getBalance();
            case 2:
              balance = _context4.v;
              totalNeeded = amountNolan + feeNolan;
              if (!(balance < totalNeeded)) {
                _context4.n = 3;
                break;
              }
              throw new Error(this.insufficientBalanceMessage(balance));
            case 3:
              _context4.n = 4;
              return this.mod.broadcastPublish({
                assetType: 'saito',
                locking: locking,
                p2shAddress: address,
                p2shHash: hash,
                amountSaito: amountSaito,
                feeSaito: feeSaito,
                callback: callback
              });
            case 4:
              newtx = _context4.v;
              this.lastPublishedTx = newtx;
              return _context4.a(2, newtx);
          }
        }, _callee4, this);
      }));
      function broadcastPublish(_x, _x2) {
        return _broadcastPublish.apply(this, arguments);
      }
      return broadcastPublish;
    }()
  }]);
}();
module.exports = PublishFlow;